import {siteName} from "@/constants/config";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PrivacySection = (props: { title: string; description: string; img: string }) => {
  const { title, description, img } = props;
  return (
    <Box>
      <Typography
        variant={"h6"}
        color={""}
        gutterBottom
        sx={{
          fontWeight: "medium",
        }}
      >
        {title}
      </Typography>
      <Typography component={"p"} color={""}>
        {description}
      </Typography>
      <img src={img} className="block max-w-[100%] mt-[10px] mx-auto" alt="" />
    </Box>
  );
};

const Content = () => {
  const data = [
    {
      title: siteName + " hotels is now available! ",
      description:
        "We're tracking the yearly availability of 600+ carefully chosen hotels across four renowned brands, Hilton, IHG, Marriott, and Hyatt. Those are top-notch hotels with a very high rating, aiming to elevate your award travel experience, and make the best use of your points!",
    },
    {
      title: "1. Search where you're going to",
      description:
        "You can search for hotels by city, brand, hotel name, or even a specific address. We'll show you the hotels that are available for the next 365 days. You can also filter the results by brand, price, and rating. On the search results page, we provide the Google rating for each hotel, along with details such as the minimum, maximum, and median point values, as well as the point price for each hotel.",
      img: "https://img.awardtool.com/guides/guide_page.jpg",
    },
    {
      title: "2. Choose the one that appeals to you and review the details.",
      description:
        "Select the option that catches your interest, take a closer look at the details, and we'll provide you with the room availability for the entire year for that particular hotel.",
      img: "https://img.awardtool.com/guides/guide_hotel_2.jpg",
    },
    {
      title: "Are you going to support more hotels?",
      description:
        "Certainly, the hotels we currently feature have been carefully chosen by us, ensuring they boast exceptional ratings across various hotel review platforms and offer excellent value for your points. Additionally, we are actively broadening our selection. Feel free to suggest any hotels you would like us to include in our tracking!",
    },
    // {
    //   title: "How can I receive more alerts?",
    //   description:
    //     "Upgrade to the pro version to receive up to 25 alerts for each account.",
    // },
    // {
    //   title: "6. How long do we keep your information?",
    //   description:
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    //   img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    // },
    // {
    //   title: "7. What are your privacy rights?",
    //   description:
    //     "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?",
    //   img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    // },
    // {
    //   title: "8. How can you review, update or delete the data we collect from you?",
    //   description:
    //     "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?",
    //   img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    // },
  ];
  return (
    <Box>
      {data.map((item, i) => (
        <Box key={i} marginBottom={i < data.length - 1 ? 4 : 0}>
          <PrivacySection {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default Content;
